import { useQuery } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getEmpLeave = async ({
  companyCode,
  employeeCode,
  leaveCode,
  fromDate,
  toDate,
  locationCode,
}) => {
  let queryString = `?companyCode=${companyCode}&LeaveFrom=${fromDate}&LeaveTo=${toDate}&LocationCode=${locationCode}`;

  if (employeeCode !== 0) {
    queryString += `&Employeecode=${employeeCode}`;
  }

  if (leaveCode !== 0) {
    queryString += `&LeaveCode=${leaveCode}`;
  }

  if (companyCode && locationCode) {
    const { data } = await http_payroll.get(
      `${Api_EndPoints.GetEmpLeave}${queryString}`
    );
    return data;
  }
  return [];
};

export const useGetEmployeeLeaveQuery = (companyCode) => {
  
  return useQuery({
    queryKey: [Api_EndPoints.GetEmpLeave],
    queryFn: () => getEmpLeave(companyCode),
    refetchOnWindowFocus: false,
  });
};
